import { productActions } from "./ProductReducer";
import { useProductAPI  } from '../../../api/product/useProductAPI';

export const useProduct = () => {
    const api = useProductAPI();
    const request = {
        get: ( params ) => {
          return async (dispatch) => {
            try {
              const response = await api.product.get(params);
              dispatch(productActions.funGetProducts(response));
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          }
        },
        post: async (data) => {
          return await api.product.post(data);
        },
        put: async (data) => {
          return await api.product.put(data);
        },
        delete: async (params) => {
          return await api.product.delete(params);
        },
        getCount: ( params ) => {
          return async (dispatch) => {
            try {
              const response = await api.product.getCount(params);
              dispatch(productActions.funSetTotalCount(response));
            } catch (error) {
              console.error('Error fetching count:', error);
            }
          }
        }
    };
    return { request };
  };